<template>
    <div style="width: 100%;" class="info-div">
        <div class="full-width-flex info-div">
            <div>
                <span tkey="顯示/隱藏">{{i18n.tkey("lang_show_hide")}}</span>&nbsp;&nbsp;
            </div>

            <div>
                <el-select style="width: 100px" v-model="editCard.worksalary">
                    <el-option
                            :key="11"
                            :label="i18n.tkey('lang_show')"
                            :value="0"
                    />

                    <el-option
                            :key="22"
                            :label="i18n.tkey('lang_hide')"
                            :value="-1"
                    />
                </el-select>
            </div>

        </div>

        <div class="info-div">
            <span tkey="分享問候語">{{i18n.tkey("lang_show_share_greetings")}}</span>:<br>
            <el-input
                    v-model="editCard.workjobduties"
                    style="width: 100%"
                    :rows="3"
                    type="textarea"
                    placeholder=""
                    show-word-limit
                    maxlength="800"
            />
        </div>

        <div>
            <el-button type="primary" @click="updateCard" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
        </div>
    </div>

</template>

<script setup>
    import {inject, onMounted, ref} from "vue";
    import cardApi from "@/request/api";
    import myUtil from "@/util/util";

    const i18n = inject("i18n")

    const editCard = ref({})
    const { getCurrCard } = inject('myCardViewFunc', { getCurrCard: () => { return null } })
    const { updateCardWhatsapp } = inject('myCardViewFunc', { updateCardWhatsapp: () => {} })

    function updateCard() {
        const request = cardApi.update
        const params = request.getParams()

        params.id = editCard.value.id
        params.worksalary = editCard.value.worksalary
        params.workjobduties = editCard.value.workjobduties

        request.send(params, (res) => {
            if (res.code == 200){
                myUtil.alertSuccess(i18n.tkey("lang_save_success"))
                updateCardWhatsapp(params.worksalary, params.workjobduties)
            }
        })

    }

    onMounted(() => {
        editCard.value = getCurrCard()

    })

</script>

<style scoped>
    .full-width-flex {
        width: 100%;
        display: flex;
    }

    .info-div {
        margin-bottom: 15px;
    }
</style>